module.exports = __webpack_public_path__ + "img/ke.f011fd6b.svg";